import request from '@/utils/httpRequest'

export default {
  save: function (inputForm) {
    return request({
      url: '/cecunmportfolio/cecUnmPortfolio/save',
      method: 'post',
      data: inputForm
    })
  },
  batchOperation: function (inputForm) {
    return request({
      url: '/cecunmportfolio/cecUnmPortfolio/batchOperation',
      method: 'post',
      data: inputForm
    })
  },

  delete: function (ids) {
    return request({
      url: '/cecunmportfolio/cecUnmPortfolio/delete',
      method: 'delete',
      params: {ids: ids}
    })
  },

  queryById: function (id) {
    return request({
      url: '/cecunmportfolio/cecUnmPortfolio/queryById',
      method: 'get',
      params: {id: id}
    })
  },

  getMaxSort: function () {
    return request({
      url: '/cecunmportfolio/cecUnmPortfolio/maxSort',
      method: 'get'
    })
  },
  list: function (params) {
    return request({
      url: '/cecunmportfolio/cecUnmPortfolio/list',
      method: 'get',
      params: params
    })
  },

  exportTemplate: function () {
    return request({
      url: '/cecunmportfolio/cecUnmPortfolio/import/template',
      method: 'get',
      responseType: 'blob'
    })
  },

  exportExcel: function (params) {
    return request({
      url: '/cecunmportfolio/cecUnmPortfolio/export',
      method: 'get',
      params: params,
      responseType: 'blob'
    })
  },

  importExcel: function (data) {
    return request({
      url: '/cecunmportfolio/cecUnmPortfolio/import',
      method: 'post',
      data: data
    })
  }
}
